import React from 'react';
import { Label } from 'react-bootstrap';
import { injectIntl, FormattedMessage, InjectedIntlProps } from 'react-intl';
import { Link } from 'react-router';
// @ts-ignore
import urlMapping from '../app/URLMapping';
import { TEST_STATUS_PASSED, TEST_STATUS_FAILED } from '../../common/types/TestTypes';
import './SnapshotGrid.scss';

export interface Snapshot {
  id: string;
  name: string;
  organisation_id: string;
  flow_id: string;
  sourceFlowInvocation_id?: string;
  lastStatus: string;
  updatedAt?: string;
  expectedOutputPreview?: string;
}

interface Props {
  snapshots: Snapshot[];
  loading?: boolean;
}

class SnapshotGrid extends React.Component<Props & InjectedIntlProps> {
  normalizeSnapshotDate(dateVal?: string | Date | number | null): Date | undefined {
    if (!dateVal) {
      return undefined;
    }

    let parsedDate = new Date(dateVal as any);

    if (isNaN(parsedDate.getTime()) && (typeof dateVal === 'string' || typeof dateVal === 'number') && !isNaN(Number(dateVal))) {
      parsedDate = new Date(Number(dateVal));
    }

    return isNaN(parsedDate.getTime()) ? undefined : parsedDate;
  }

  getStatusLabel(status: string) {
    let bsStyle = 'default';
    if (status === TEST_STATUS_PASSED) bsStyle = 'success';
    if (status === TEST_STATUS_FAILED) bsStyle = 'danger';

    return <Label bsStyle={bsStyle}>{status}</Label>;
  }

  render() {
    const { snapshots, intl, loading } = this.props;

    if (loading) {
      return (
        <div className="snapshot-testing-grid__loading">
          <FormattedMessage defaultMessage="Loading snapshots..." id="snapshotTesting.loading" />
        </div>
      );
    }

    if (!snapshots || snapshots.length === 0) {
      return (
        <div className="snapshot-testing-grid__empty">
          <FormattedMessage defaultMessage="No snapshots found." id="snapshotTesting.noSnapshots" />
        </div>
      );
    }

    return (
      <div className="snapshot-testing-grid">
        <div className="snapshot-testing-grid__header">
          <div><FormattedMessage defaultMessage="Name" id="snapshotTesting.name" /></div>
          <div><FormattedMessage defaultMessage="Status" id="snapshotTesting.status" /></div>
          <div><FormattedMessage defaultMessage="Updated At" id="snapshotTesting.updatedAt" /></div>
          <div><FormattedMessage defaultMessage="Preview" id="snapshotTesting.preview" /></div>
        </div>
        <div className="snapshot-testing-grid__body">
          {snapshots.map(snapshot => (
            (() => {
              const normalizedUpdatedAt = this.normalizeSnapshotDate(snapshot.updatedAt);

              return (
            <div className="snapshot-testing-grid__row" key={snapshot.id}>
              <div className="snapshot-testing-grid__cell snapshot-testing-grid__cell--name">
                <div>{snapshot.name}</div>
                {snapshot.sourceFlowInvocation_id && (
                  <div className="snapshot-testing-grid__invocation-link">
                    <small>
                      <Link to={urlMapping.getUrl('flowInvocations', 'view', {
                        organisation_id: snapshot.organisation_id,
                        flow_id: snapshot.flow_id,
                        id: snapshot.sourceFlowInvocation_id
                      })}>
                        <FormattedMessage defaultMessage="view invocation" id="snapshotTesting.viewInvocationLink" />
                      </Link>
                    </small>
                  </div>
                )}
              </div>
              <div className="snapshot-testing-grid__cell snapshot-testing-grid__cell--status">
                {this.getStatusLabel(snapshot.lastStatus)}
              </div>
              <div className="snapshot-testing-grid__cell snapshot-testing-grid__cell--updated">
                {normalizedUpdatedAt ? (
                  <span>
                    {intl.formatDate(normalizedUpdatedAt)} {intl.formatTime(normalizedUpdatedAt)}
                  </span>
                ) : '-'}
              </div>
              <div className="snapshot-testing-grid__cell">
                <pre className="snapshot-testing-grid__preview">
                  <code>{snapshot.expectedOutputPreview}</code>
                </pre>
              </div>
            </div>
              );
            })()
          ))}
        </div>
      </div>
    );
  }
}

export default injectIntl(SnapshotGrid);
